<template>
  <div class="reward-stars-container">
    <div class="d-flex justify-content-center w.100 align-items-center ">
      <span class="reward-stars-number">
        {{ value }}
      </span>
      <b-img
        v-if="showStar"
        :src="require('@/assets/star.png')"
        class="icon-star-small ml-1"
      ></b-img>
    </div>
    <span class="reward-stars-title d-flex justify-content-center px-2">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    value: Number,
    first: {
      type: Boolean,
      default: false,
    },
    showStar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.reward-stars-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 210px;
  @media (max-width: 600px) {
    flex-wrap: nowrap;
    width: 100%;
  }
  .reward-stars-title,
  .reward-stars-number {
    letter-spacing: 0;
    color: #000000;
  }
  .reward-stars-number {
    font-weight: 600;
    font-size: 20px;
    @media (max-width: 601px) {
      font-size: 15px;
    }
  }
  .reward-stars-title {
    font-weight: 500;
    font-size: 16px;
    @media (min-width: 601px) {
      width: 100%;
    }
    @media (max-width: 601px) {
      font-size: 15px;
    }
  }
}
</style>
